import { useEffect, useState } from 'react';
import { subscribeAppToast } from '../../utils/appToast';
import ToastPortal from './ToastPortal';

export default function GlobalToast() {
  const [toast, setToast] = useState(null);

  useEffect(() => subscribeAppToast((detail) => setToast(detail)), []);

  useEffect(() => {
    if (!toast) return undefined;
    const timer = window.setTimeout(() => setToast(null), 5000);
    return () => window.clearTimeout(timer);
  }, [toast]);

  return <ToastPortal toast={toast} onClose={() => setToast(null)} />;
}
